<ul class="nav flex-column">

    <ng-container *ngFor="let menuItem of menuItems;let i=index">
        <ng-container *ngIf="menuItem.isGranted()">
            <ng-container *ngIf="menuItem.subMenu; else menuItem_content">
                <li class="nav-item d-inline-block" ngbDropdown [class.show]="isDropDownOpen">
                    <a [qcId]="menuItem.locator" class="nav-link" (click)="ToggleDropDown()" [class.active]=" i == 0" routerLinkActive="active" ngbDropdownToggle>
                        <i class="icon {{menuItem.icon}}"></i>
                        <span class="title">{{menuItem.title}}</span>
                    </a>

                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" [class.show]="isDropDownOpen">
                        <a *ngFor="let subMenuItem of menuItem.subMenu;let i=index" class="nav-link"
                            [qcId]="subMenuItem.locator" [ngClass]="subMenuItem.class" ngbDropdownItem
                            [routerLink]="[subMenuItem.path]" routerLinkActive="activeSub">
                            <i class="fa-solid fa-circle"></i>
                            <span> {{subMenuItem.title}}</span>
                        </a>
                    </div>

                </li>
            </ng-container>
            <ng-template #menuItem_content>
                <li class="nav-item" (click)="CloseDropDown()">
                    <a class="nav-link" [class.active]=" i == 1" [routerLink]="[menuItem.path]" routerLinkActive="active">
                        <i class="icon {{menuItem.icon}}"></i>
                        <span class="title">{{menuItem.title}}</span>
                    </a>
                </li>
            </ng-template>
        </ng-container>
    </ng-container>
</ul>
<div class="user d-flex">
    <div class="user-info d-flex">
        <div class="user-image">
            <img src="../../../../assets/images/Avatar.png" alt="franchise">
        </div>
        <div class="user-role">
            <p class="user-name">{{userProfileDto.name}}</p>
            <p class="role">مدير النظام</p>
        </div>
    </div>
    <div class="logout" style="cursor: pointer;">
        <a (click)="logout()">
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
        </a>
    </div>
</div>